<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
        <b-row>
          <b-col sm="6">
            <b-form-group label="Bhandara/Satsang">
              <event-type-select v-model="eventType"></event-type-select>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Year">
              <v-select :options="yearList" v-model="year" placeholder="Select Year"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-button variant="primary" class="pull-right" @click="search" :disabled="!isValid">
              Search
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>

    <b-card no-body v-if="reportData">
      <v-client-table :data="reportData" :columns="columns" :options="options" :theme="theme">
      </v-client-table>

      <ul>
        <li>Total number of people stayed: {{ totalPeople }}</li>
        <li>Total number of night occupied: {{ totalDays }}</li>
      </ul>
    </b-card>

  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import { required } from "vuelidate/lib/validators"
  import EventTypeSelect from '../../components/EventTypeSelect'

  export default {
    name: 'EventReport',
    components: {
      EventTypeSelect
    },
    computed: {
      isValid() {
        if (this.eventType) {
          return true
        }

        return this.eventType && this.year
      }
    },
    data: function () {
      return {
        yearList: [],
        eventType: null,
        year: null,
        reportData: null,
        totalPeople: 0,
        totalDays: 0,
        columns: [
          'building.name',
          'total_people',
          'total_days',
        ],
        options: {
          headings: {
            'building.name': 'Builing Name',
            total_people: 'Number of People Stayed',
            total_days: 'Number of Night Occupied',
          },
          sortable: [],
          filterable: [],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,
        },
        theme: 'bootstrap4',
      }
    },
    methods: {
      search() {
        this.reportData = null
        let params = {
          event_id: this.eventType.value,
          year: this.year,
        }
        Vue.axios.get('/admin/reports/event', {params: params})
          .then(response => {
            this.reportData = response.data.data
            _.each (this.reportData, (item) => {
              this.totalPeople += item.total_people
              this.totalDays += item.total_days
            })
            this.showSuccessMsg()
          })
          .catch(() => {
            this.showErrorMsg()
          })
      },
    },
    created () {
      Vue.axios.get('/admin/reports/years')
        .then(response => {
          _.each(response.data, (year) => {
            this.yearList.push(year)
          })
        })
        .catch((error) => {
          this.showErrorMsg({message: error})
        })
    }
  }
</script>
